export default function validationError(type, value, context, message) {
  return {
    type,
    value,
    context,
    message
  };
}